export default __webpack_public_path__ + "static/media/me.0847447c.jpg";